import { render } from "./OutlierPieChart.vue?vue&type=template&id=3ff8da08"
import script from "./OutlierPieChart.vue?vue&type=script&lang=js"
export * from "./OutlierPieChart.vue?vue&type=script&lang=js"

import "./OutlierPieChart.vue?vue&type=style&index=0&id=3ff8da08&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__